interface TrashIconProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  stroke?: string;
  strokeWidth?: string | number;
}

export const TrashIcon = (props: TrashIconProps) => {
  const width = props.width ?? 16;
  const height = props.height ?? 16;
  const stroke = props.stroke ?? "#BB0202";
  const strokeWidth = props.strokeWidth ?? 1.2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={props.className}
    >
      <path
        d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4M6.66667 7V10.3333M9.33333 7V10.3333"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
